export default "__VITE_ASSET__B0JCoAmm__"